import React, { useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../../share/context/auth-context';
import useHttpClient from '../../../../share/hook/http-hook';

function LoginSuccessView() {
    const auth = useContext(AuthContext);

    // Get route parameter
    let { userId, token } = useParams();

    // http-hook
    const { sendRequest } = useHttpClient();

     // to navigate the url
     const navigate = useNavigate();




    // useEffect to fetch the data for the first time only without redenring
    useEffect(() => {
        // header include token to check authen
        const headers = { Authorization: 'Bearer ' + token + ' ' + userId };

       
        const fetchData = async () => {
            try {
                const response = await sendRequest(process.env.REACT_APP_BACKEND_URL + '/auth/check',
                    'GET', null, headers);
                // 
                const tokenExpirationDate = new Date(new Date().getTime() + 1000 * 60 * 60);
                auth.login(response.user.userId, response.user.token, tokenExpirationDate);
                //let newData = response.user;
                //newData.expiration = tokenExpirationDate;
                localStorage.setItem('userData', JSON.stringify(
                    {
                        userId: response.user.userId,
                        token: response.user.token,
                        expiration: tokenExpirationDate.toISOString()
                    }
                ));

                // remove userid & token from route params
                //window.history.replaceState(null, null, `${window.location.origin}/baocon`);
                navigate('/baocon/info');
                //navigate('/baocon/info', {replace: true});
            } catch (err) {
                console.log(err);
            };
        };
        fetchData();

    }, [sendRequest, auth, navigate, userId, token]);
    return (
        <div className="mt-5">
            <h2>{userId}</h2>
            <h5>{token}</h5>
        </div>
    );

}

export default LoginSuccessView;